import { noop } from 'rxjs';
import { I4BCellType, I4BColumnConfiguration } from './configurations';
import { GET_DEFAULT_DEVICES_COLUMNS_FOR_DEVICES_VIEW } from './default-device-grid.definition';
import { getDefaultColumnsByConcept } from './default-columns.registry';
import { DaliaFirmwareVersionColumn, DeviceTypeGroupColumn, I4BColumn, I4BSelectionColumn, NameColumn, NteDeviceButtonColumn } from './definitions';
import { I4bCellConcept } from './enums';
import { HeaderType, I4BColumnHeader, I4BGrid, I4BGridOptions, NteDevicesGridData } from './models';
import { I4BColumnOptions } from './options';

export const GET_DEFAULT_DEVICES_COLUMNS_FOR_NTE_DEVICES_VIEW = (): I4BColumn<I4BColumnHeader, I4BColumnConfiguration, I4BColumnOptions>[] =>
  [...GET_DEFAULT_DEVICES_COLUMNS_FOR_DEVICES_VIEW()]
    .map((cell) => {
      cell.configuration.isDefault = false;
      if (
        cell.configuration.id === 'name' ||
        cell.configuration.id === 'identifier' ||
        cell.configuration.id === 'deviceType' ||
        cell.configuration.id === 'status.name' ||
        cell.configuration.id === 'communication.operator' ||
        cell.configuration.id === 'lastCallStatus.datetime' ||
        cell.configuration.id === 'communication.endpoint' ||
        cell.configuration.id === 'communication.iccid'
      ) {
        cell.configuration.isDefault = true;
      }
      if (cell.configuration.id === 'deviceType') {
        cell.options.order = 8;
      }
      return cell;
    })
    .filter(
      (cell) =>
        cell.configuration.id !== 'name' &&
        cell.configuration.id !== 'type.firmware' &&
        cell.configuration.id !== 'deviceType' &&
        cell.configuration.id !== 'totalComments'
    )
    .concat([
      new NameColumn(
        { displayName: 'NAME', type: HeaderType.ICON_AND_TEXT, icon: 'device' },
        {
          id: 'name',
          translationKey: 'MASTER_VIEW_ENGINE.TABLE.HEADER_NAME.DEVICE_NAME',
          concept: I4bCellConcept.DEVICES,
          autoSize: true,
          isDefault: true,
          cell: { type: I4BCellType.BASIC_LINK, event: { type: 'navigateToDevice' } }
        },
        { order: 1, pinned: 'left', width: 200 }
      ),
      new DeviceTypeGroupColumn(
        { displayName: 'DEVICE TYPE FULL' },
        {
          id: 'deviceType',
          isDefault: true,
          cell: {
            type: I4BCellType.BASIC,
            options: {
              toFixed: 3
            }
          }
        },
        { order: 13 }
      ),
      new DaliaFirmwareVersionColumn(
        { displayName: 'FIRMWARE' },
        {
          id: 'type.firmware',
          translationKey: 'MASTER_VIEW_ENGINE.TABLE.HEADER_NAME.DEVICE_TYPE_FIRMWARE',
          cell: {
            type: I4BCellType.BASIC,
            options: {}
          },
          isDefault: false,
          sortProperty: 'type.firmware',
          concept: I4bCellConcept.DEVICES,
          width: 130
        },
        {
          order: 5
        }
      )
    ]);

export class DefaultNteDevicesGrid implements I4BGrid<I4BGridOptions, NteDevicesGridData> {
  masterview = 'nte-devices';
  isDefault = false;
  isUserDefault = false;
  isAppDefault = false;
  name = null;
  userId = null;
  data: NteDevicesGridData = {
    response: {
      data: [],
      pagination: null
    }
  };
  gridOptions: I4BGridOptions = {
    pageSize: 100,
    multipleSelection: false,
    autoRefresh: { enabled: true, delay: 120 },
    gridSort: [{ colId: 'name', sort: 'asc', sortIndex: 2 }],
    buttonColumn: { enabled: true, className: new NteDeviceButtonColumn() },
    selectionColumn: { enabled: true, className: new I4BSelectionColumn() }
  };
  columns: I4BColumn<I4BColumnHeader, I4BColumnConfiguration, I4BColumnOptions>[] = [...getDefaultColumnsByConcept(this.masterview)];

  export = () => noop();
}
